import './Header.scss';

import { b2x } from '@b2x/react/src';

import { useAppContext, useAppStaticContext } from './AppContext';
import { Button } from './Button';
import { Container } from './Container';
import { t } from './i18n/i18n';
import { Icon } from './Icon';
import logo from './images/logo.svg';

export interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const { headerCheckout } = useAppContext();

  return (
    <b2x.Sticky className="Header" offset={-1}>
      {!headerCheckout ? (
        <b2x.Div className="bg-gray-500 text-center py-3" role="banner">
          <Container>
            <b2x.Row>
              <b2x.Col></b2x.Col>
              <b2x.Col>
                <b2x.router.NavLink
                  aria-label={t('accessibility.logo.goToHome', { brandName: t('misc.storeName') })}
                  to="/"
                >
                  <b2x.Image className="logo" src={logo} />
                </b2x.router.NavLink>
              </b2x.Col>
              <b2x.Col>
                <b2x.Div alignItems={'center'} display={'flex'} justifyContent={'end'} style={{ height: '100%' }}>
                  <Toggles />
                </b2x.Div>
              </b2x.Col>
            </b2x.Row>
          </Container>
        </b2x.Div>
      ) : (
        <b2x.Div className="header-checkout" role="banner">
          <b2x.Div className="bg-gray-500 text-center py-3">
            <b2x.router.Link aria-label={t('accessibility.logo.goToHome', { brandName: t('misc.storeName') })} to="/">
              <b2x.Image className="logo" src={logo} />
            </b2x.router.Link>
          </b2x.Div>
          <b2x.Div className="bg-gray-100 py-3">
            <Container>
              <b2x.Cta
                aria-label={t('accessibility.button.swiper_prev')}
                button={{
                  className: 'px-1 text-uppercase',
                  iconStart: { name: 'arrow-left', size: 20 },
                  label: t('checkout.backToCart'),
                  variant: 'blank',
                }}
                href="/cart"
              />
            </Container>
          </b2x.Div>
        </b2x.Div>
      )}
    </b2x.Sticky>
  );
};

const Toggles = () => {
  const { session } = b2x.useAppContext();

  const { showAccountOffcanvas, showCartOffcanvas } = useAppStaticContext();

  return (
    <div className="toggles">
      <div className="hstack gap-2">
        {session?.customer ? (
          <b2x.Cta
            ariaLabel={t('accessibility.icons.account')}
            button={{
              className: 'text-white px-2 px-lg-1',
              iconStart: { name: 'account-logged-in', size: 28 },
              variant: 'blank',
            }}
            code="SITE_ACCOUNT"
          />
        ) : (
          <Button
            aria-label={t('accessibility.icons.account_login')}
            className="text-white px-2 px-lg-1"
            iconEnd={{ name: 'account', size: 28 }}
            onClick={showAccountOffcanvas}
            variant="blank"
          />
        )}
        <Button
          aria-label={
            session?.cart?.itemsNumber !== undefined && session.cart.itemsNumber > 0
              ? t('accessibility.icons.cart_not_empty', { items: session.cart.itemsNumber })
              : t('accessibility.icons.cart')
          }
          className="btn-cart position-relative text-white px-1"
          onClick={showCartOffcanvas}
          variant="blank"
        >
          <Icon name={'cart'} size={28} />
          {session?.cart?.itemsNumber !== undefined && session.cart.itemsNumber > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle text-white fw-light small">
              {session.cart.itemsNumber}
            </span>
          )}
        </Button>
      </div>
    </div>
  );
};
